module.exports = __webpack_public_path__ + "img/Weapon_64.c0b46689.png";